import { z } from "zod"

const stringToBoolean = z
  .enum(["true", "false"])
  .transform((value) => value === "true")

const unset = z.literal("").transform(() => undefined)

const stringToUrl = z.string().transform((url, ctx) => {
  try {
    return new URL(url)
  } catch {
    ctx.addIssue({ code: z.ZodIssueCode.custom, message: "Invalid URL" })
    return z.NEVER
  }
})

const Env = z.object({
  PRISMIC_AI_SERVICE_BASE_URL: stringToUrl,
  PRISMIC_AI_SERVICE_WEBSOCKET_ENDPOINT: stringToUrl,
  PRISMIC_AMPLITUDE_EXPERIMENT_SERVER_BASE_URL: stringToUrl,
  PRISMIC_ASSETS_API_BASE_URL: stringToUrl,
  PRISMIC_AUTHENTICATION_SERVER_BASE_URL: stringToUrl,
  PRISMIC_BILLING_SERVICE_BASE_URL: stringToUrl,
  PRISMIC_CUSTOM_TYPES_API_BASE_URL: stringToUrl,
  PRISMIC_DOCUMENT_SEARCH_BASE_URL: stringToUrl,
  PRISMIC_EMBED_API_ENDPOINT: stringToUrl,
  PRISMIC_INTEGRATION_FIELDS_API_BASE_URL: stringToUrl,
  PRISMIC_LOCALES_API_BASE_URL: stringToUrl,
  PRISMIC_REPOSITORY_BASE_URL: stringToUrl,
  PRISMIC_ROLE_API_BASE_URL: stringToUrl,
  PRISMIC_UNSPLASH_API_BASE_URL: stringToUrl,
  PRISMIC_USAGE_SERVICE_BASE_URL: stringToUrl,
  PRISMIC_USER_SERVICE_BASE_URL: stringToUrl,

  PRISMIC_WROOM_BASE_URL: stringToUrl,

  PRISMIC_INTERCOM_APP_ID: z.string().min(1),

  PRISMIC_PAGE_BUILDER_AMPLITUDE_EXPERIMENT_DEPLOYMENT_KEY: z.string().min(1),
  PRISMIC_PAGE_BUILDER_AUTH_STRATEGY: z.enum(["cookie", "token"]),
  PRISMIC_PAGE_BUILDER_FALLBACK_REPOSITORY_NAME: z.string().min(1).or(unset),
  PRISMIC_PAGE_BUILDER_SENTRY_DSN: z.string().min(1),
  PRISMIC_PAGE_BUILDER_SENTRY_ENABLED: stringToBoolean,
  PRISMIC_PAGE_BUILDER_SENTRY_ENVIRONMENT: z.enum([
    "dev",
    "stage",
    "prod",
    "dev-tools",
    "marketing-tools",
    "platform",
  ]),

  PRISMIC_STRIPE_PLATINUM_PRICE_IDS: z
    .string()
    .transform((str) => str.split(","))
    .pipe(z.array(z.string().min(1))),

  VITE_VERCEL_URL: z.string().min(1).optional(),
  PRISMIC_DOMAIN: z.string().min(1),

  PRISMIC_GIT_COMMIT_HASH: z.string().min(1).optional(),

  PRISMIC_DEMO: stringToBoolean,
  PRISMIC_DEMO_API_BASE_URL: stringToUrl,
  PRISMIC_USERCENTRICS_SETTINGS_ID: z.string().min(1),
  PRISMIC_USERCENTRICS_VERSION: z.string().optional(),
  PRISMIC_SEGMENT_WRITE_KEY: z.string().min(1),
})

export const env = Env.parse(import.meta.env)
